var _desc, _defs, _rect, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoonly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Voluu favicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Dark rounded app icon with intertwined orange, pink, and purple heart loops.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGlow",
    cx: "74%",
    cy: "18%",
    r: "86%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f1ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2a092e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotStroke",
    x1: 9,
    y1: 8,
    x2: 55,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ef2d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b35ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spark",
    x1: 41,
    y1: 12,
    x2: 51,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd28c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4fa2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 3,
    floodColor: "#ef2d85",
    floodOpacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    fill: "url(#bgGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52C18 38 35 52 64 31v33H0Z",
    fill: "#120514",
    opacity: 0.72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 44.5C16.2 38.8 10 33.7 10 25.8c0-6.1 4.4-10.7 10-10.7 3.7 0 6.6 1.6 8 4.2 1.4-2.6 4.3-4.2 8-4.2 5.6 0 10 4.6 10 10.7 0 7.9-6.2 13-12.7 18.7L28 49.2Z",
    stroke: "#ff7a00",
    strokeWidth: 5.2,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 44.5C29.3 38.8 23 33.7 23 25.8c0-6.1 4.4-10.7 10-10.7 3.7 0 6.6 1.6 8 4.2 1.4-2.6 4.3-4.2 8-4.2 5.6 0 10 4.6 10 10.7 0 7.9-6.2 13-12.7 18.7L41 49.2Z",
    stroke: "url(#hotStroke)",
    strokeWidth: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 48.2C21.9 41.8 15 36.1 15 27.2c0-6.8 4.9-12 11.2-12 4.1 0 7.4 1.8 8.9 4.7 1.6-2.9 4.8-4.7 9-4.7",
    stroke: "#ff3b9f",
    strokeWidth: 3.2,
    opacity: 0.72
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24c-0.6-4.5 2.7-8.1 7-8.5-4.3-0.4-7.6-4-7-8.5-0.6 4.5-3.9 8.1-8.2 8.5 4.3 0.4 7.6 4 8.2 8.5Z",
    fill: "url(#spark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoonly);
export default __webpack_public_path__ + "static/media/logoonly.a18026e646c29eae874bc57b54e48b4b.svg";
export { ForwardRef as ReactComponent };